// Layout de dos columnas para el login (split 60/40 en desktop):
//   - izquierda: panel hero teal con frase dinámica (60%, oculto en móvil)
//   - derecha: formulario sobre superficie blanca (40%)
// Exclusivo del login. Las demás pantallas de auth (cambio de contraseña,
// recuperación, 2FA) siguen usando el `AuthLayout` centrado de una columna.
export function AuthSplitLayout({ hero, form }) {
  return `
    <div class="min-h-screen grid grid-cols-1 lg:grid-cols-[3fr_2fr]">
      ${hero}
      <div class="flex items-center justify-center bg-white px-6 py-12 sm:px-12">
        <div class="w-full max-w-md enter enter-delay-1">
          ${form}
        </div>
      </div>
    </div>
  `
}
